import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PersonIcon from "@mui/icons-material/Person";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LockIcon from "@mui/icons-material/Lock";
import LogoutIcon from "@mui/icons-material/Logout";
import { Divider, ListItemIcon } from "@mui/material";
import { images } from "../../config/images";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import profileImg from "../../assets/images/user_male_icon.png";
import expandScreen from "../../assets/images/expandScreen.png";
import { clearUserDetails, setUserDetails } from "../Login/slice/userSlice";
import "./header.css";
import { ToastContainer, toast } from "react-toastify";
import { setHeaderDetails } from "./headerSlice";
import { Session } from "../../components/SessionTimeout/Session";
import { logout } from "./service";
import { setUserLogin } from "../Login/slice/userLoginSlice";
import PrintIcon from "@mui/icons-material/Print";
import AnalyticsIcon from "@mui/icons-material/Analytics";

export default function Header() {
  const {
    firstName,
    lastName,
    email,
    mobileNoRe,
    company_logo,
    is_super_admin,
    user_access,
    redirectHikPred,
    is_created_by_super_admin_user_company,
    token,
  } = useSelector((state) => state.userState);

  const [isFullscreen, setIsFullscreen] = useState();
  const { selectTimeZoneProfile, is_csv_record_access, is_printer_status_access} = useSelector(
    (state) => state.userState
  );
  const navigate = useNavigate();
  // const { headerName, headerImageSrc, isFullscreen } = useSelector(
  //     (state) => state.headerState
  //   );

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const dispatch = useDispatch();
  const notifyError = (message) => {
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const handleTostMsg = () => {
    notifyError("You don't have access");
  };
  useEffect(() => {
    const updateDateTime = (timeZone) => {
      const tempDate = new Date();
      const options = {
        timeZone: timeZone || defaultTimeZone, // Use the selected time zone
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false, // 24-hour format
      };

      const formatter = new Intl.DateTimeFormat("en-US", options);

      document.getElementById("currentDateTime").textContent =
        formatter.format(tempDate);
    };

    updateDateTime(selectTimeZoneProfile);

    const intervalId = setInterval(
      () => updateDateTime(selectTimeZoneProfile),
      1000
    );

    return () => clearInterval(intervalId);
  }, [selectTimeZoneProfile]); // Re-run effect when selectTimeZoneProfile changes

  // const openFullscreen = () => {
  //     const element = document.documentElement; // Adjust this selector as needed

  //     if (!isFullscreen) {
  //         console.log("here", element.requestFullscreen)
  //         try {
  //             if (element.requestFullscreen) {
  //                 element.requestFullscreen();
  //             } else if (element.webkitRequestFullscreen) {
  //                 element.webkitRequestFullscreen();
  //             } else if (element.msRequestFullscreen) {
  //                 element.msRequestFullscreen();
  //             }
  //             dispatch(setHeaderDetails({ isFullscreen: true }));
  //         } catch (error) {
  //             console.error("Fullscreen request failed:", error);
  //         }
  //     } else {
  //         console.log("here else")
  //         try {
  //             if (document.exitFullscreen) {
  //                 document.exitFullscreen();
  //             } else if (document.webkitExitFullscreen) {
  //                 document.webkitExitFullscreen();
  //             } else if (document.msExitFullscreen) {
  //                 document.msExitFullscreen();
  //             }
  //             dispatch(setHeaderDetails({ isFullscreen: false }));
  //         } catch (error) {
  //             console.error("Fullscreen exit failed:", error);
  //         }
  //     }
  // };

  const openFullscreen = () => {
    const element = document.documentElement; // The target element for fullscreen

    if (!isFullscreen) {
      if (element.requestFullscreen) {
        element
          .requestFullscreen()
          .then(() => {
            setIsFullscreen(true); // Update fullscreen state only after success
            dispatch(setHeaderDetails({ isFullscreen: true }));
          })
          .catch((error) => {
            console.error("Fullscreen request failed:", error);
          });
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
        setIsFullscreen(true);
        dispatch(setHeaderDetails({ isFullscreen: true }));
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
        setIsFullscreen(true);
        dispatch(setHeaderDetails({ isFullscreen: true }));
      }
    } else {
      if (document.exitFullscreen) {
        document
          .exitFullscreen()
          .then(() => {
            setIsFullscreen(false); // Update fullscreen state only after success
            dispatch(setHeaderDetails({ isFullscreen: false }));
          })
          .catch((error) => {
            console.error("Fullscreen exit failed:", error);
          });
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
        setIsFullscreen(false);
        dispatch(setHeaderDetails({ isFullscreen: false }));
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
        setIsFullscreen(false);
        dispatch(setHeaderDetails({ isFullscreen: false }));
      }
    }
  };

  const defaultTimeZone = "Asia/Kolkata"; // Default to a valid time zone if needed
  const handleLogOut = async () => {
    try {
      const resp = await logout();
      if (resp.status === 200 || resp.status === 201) {
        dispatch(setUserLogin({ userName: null }));
        dispatch(clearUserDetails());
        navigate("/");
        window.location.reload(false);
        localStorage.clear();
      } else {
        console.error("Logout failed with status:", resp.status);
      }
    } catch (error) {
      console.error("Error occurred during logout:", error);
    }
  };

  return (
    <>
      <Session />
      <AppBar position="static" className="header-wrapper">
        <Container maxWidth="none">
          <Toolbar disableGutters className="toolbarWrap">
            <div className="headerTitle-wrap">
              <Typography
                variant="h6"
                noWrap
                component="a"
                onClick={() => {
                  navigate("/dashboard");
                }}
              >
                <img src={images.logo} alt="logo" className="headerLogo" />
              </Typography>
            </div>
            <Box sx={{ flexGrow: 0 }} className="headerToolbar-wrap">
              <div className="dateTime-wrap">
                <p id="currentDateTime"></p>
              </div>
              <div
                className="expandScreen-btn exclude-me"
                onClick={openFullscreen}
                style={{ cursor: "pointer" }}
              >
                {isFullscreen ? (
                  <img src={images.minimizeScreen} alt="Minimize Screen" />
                ) : (
                  <img src={expandScreen} alt="Expand Screen" />
                )}
              </div>
              <div
                onClick={handleClick}
                className="profileToggle-menu exclude-me"
              >
                <Avatar
                  alt=""
                  src={profileImg}
                  className="profile-toggle-img"
                />
                <p className="profileName">
                  {firstName} {lastName}
                </p>
                <KeyboardArrowDownIcon className="ToggleIcon" />
              </div>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgb(84, 108, 138))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: -27,
                      right: 0,
                      width: 0,
                      height: 0,
                      borderLeft: "25px solid transparent",
                      borderRight: "25px solid transparent",
                      borderBottom: "50px solid #fff",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem>
                  <div className="profile-item">
                    <Avatar alt="" src={profileImg} className="profile-image" />
                    <div className="profile-detail">
                      <p className="userName">
                        {firstName} {lastName}
                      </p>
                      <p className="userEmail">{email}</p>
                    </div>
                  </div>
                </MenuItem>
                <Divider />
                <MenuItem
                  className="menu-item"
                  sx={{ px: 3, py: 2 }}
                  onClick={() => {}}
                >
                  <ListItemIcon>
                    <PersonIcon fontSize="small" />
                  </ListItemIcon>
                  Profile
                </MenuItem>
                {is_csv_record_access ? (
                  <MenuItem
                    className="menu-item"
                    sx={{ px: 3, py: 2 }}
                    onClick={() => navigate("/footfall-report")}
                  >
                    <ListItemIcon>
                      <AnalyticsIcon fontSize="small" />
                    </ListItemIcon>
                    FootFall Report
                  </MenuItem>
                ) : (
                  ""
                )}
                {is_csv_record_access ? (
                  <MenuItem
                    className="menu-item"
                    sx={{ px: 3, py: 2 }}
                    onClick={() => navigate("/upload-csv")}
                  >
                    <ListItemIcon>
                      <UploadFileIcon fontSize="small" />
                    </ListItemIcon>
                    UID print summary
                  </MenuItem>
                ) : (
                  ""
                )}
                {is_printer_status_access ? (
                  <MenuItem
                  className="menu-item"
                  sx={{ px: 3, py: 2 }}
                  onClick={() => navigate("/printer-health")}
                >
                  <ListItemIcon>
                    <PrintIcon fontSize="small" />
                  </ListItemIcon>
                  Printer Health Status
                </MenuItem>
                )   : ""}
              
                {/* <MenuItem
                  className="menu-item"
                  sx={{ px: 3, py: 2 }}
                  onClick={""}
                >
                  <ListItemIcon>
                    <DashboardIcon fontSize="small" />
                  </ListItemIcon>
                  Admin Dashboard
                </MenuItem> */}
                <MenuItem
                  className="menu-item"
                  sx={{ px: 3, py: 2 }}
                  onClick={""}
                >
                  <ListItemIcon>
                    <img src={images.passwordImg} alt="" class />
                  </ListItemIcon>
                  Change Password
                </MenuItem>
                <MenuItem
                  className="menu-item"
                  sx={{ px: 3, py: 2 }}
                  onClick={() => handleLogOut()}
                >
                  <ListItemIcon>
                    <LogoutIcon fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
}